<template>
  <div class="import-container" style="text-align: center;">
    <h5>班级群二维码上传</h5>
    <el-upload
      class="upload-zip"
      ref="uploadRef"
      action=""
      :http-request="handleUpload"
      :before-upload="beforeUpload"
      accept=".zip"
      auto-upload="false"
    >
      <template #trigger>
        <el-button type="primary">选择压缩文件</el-button>
      </template>
    </el-upload>
    <el-button
      style="margin-left: 10px;"
      type="success"
      @click="submitFile"
      :loading="loading"
    >预览二维码</el-button>

    <el-dialog v-model="dialogVisible" title="二维码预览" width="70%">
      <div class="preview-tip">
        上传后将<b style="color:#f56c6c;">清空所有旧二维码</b>，并替换为下列二维码。请确认无误后点击“确认上传”。
      </div>
      <div class="preview-summary">
        共 <b>{{ previews.length }}</b> 张，正常 <b style="color:green;">{{ okCount }}</b> 张，错误 <b style="color:red;">{{ errorCount }}</b> 张
      </div>
      <div class="preview-grid">
        <div v-for="(p, i) in previews" :key="i" class="preview-item" :class="{ 'preview-error': p.status === '错误' }">
          <div class="preview-label">{{ p.label }}</div>
          <img v-if="p.image" :src="p.image" alt="二维码" class="preview-img">
          <div v-else class="preview-noimg">无图片</div>
          <div v-if="p.status === '错误'" class="preview-errmsg">{{ p.error }}</div>
        </div>
      </div>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button v-if="canConfirm" type="primary" :loading="loading" @click="confirmUpload">确认上传</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus';
import axios from 'axios';

export default {
  name: 'ImportPage',
  data() {
    return {
      file: null,
      loading: false,
      dialogVisible: false,
      previews: [],
    };
  },
  computed: {
    okCount() {
      return this.previews.filter((p) => p.status === '正常').length;
    },
    errorCount() {
      return this.previews.filter((p) => p.status === '错误').length;
    },
    canConfirm() {
      return this.previews.length > 0 && this.previews.every((p) => p.status !== '错误');
    },
  },
  methods: {
    beforeUpload(file) {
      this.file = file;
      return false;
    },
    handleUpload() {},
    submitFile() {
      if (!this.file) {
        ElMessage.error('请先选择一个文件');
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append('file', this.file);
      axios.post('/api/preview_zip', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }).then((response) => {
        this.loading = false;
        this.previews = response.data.previews || [];
        this.dialogVisible = true;
      }).catch((error) => {
        this.loading = false;
        ElMessage.error(error.response?.data?.error || '预览失败');
      });
    },
    confirmUpload() {
      if (!this.file) {
        ElMessage.error('文件已失效，请重新选择');
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append('file', this.file);
      axios.post('/api/confirm_zip', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }).then(() => {
        this.loading = false;
        ElMessage.success('二维码已更新');
        this.dialogVisible = false;
        this.previews = [];
        this.file = null;
        this.$refs.uploadRef.clearFiles();
      }).catch((error) => {
        this.loading = false;
        ElMessage.error(error.response?.data?.error || '上传失败');
      });
    },
  },
};
</script>

<style scoped>
.import-container {
  padding: 20px;
}
.preview-tip {
  margin-bottom: 8px;
  font-size: 14px;
  color: #606266;
}
.preview-summary {
  margin-bottom: 12px;
  font-size: 14px;
  color: #303133;
}
.preview-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: flex-start;
}
.preview-item {
  width: 160px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 10px;
  text-align: center;
}
.preview-error {
  border-color: #f56c6c;
}
.preview-label {
  font-weight: 600;
  margin-bottom: 8px;
  color: #303133;
}
.preview-img {
  width: 130px;
  height: 130px;
  object-fit: contain;
}
.preview-noimg {
  width: 130px;
  height: 130px;
  line-height: 130px;
  color: #909399;
}
.preview-errmsg {
  margin-top: 6px;
  color: #f56c6c;
  font-size: 12px;
}
.upload-zip {
  margin-bottom: 10px;
}
</style>